var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 677 677",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.003 284.456L338.47 152.988L469.999 284.512L546.494 208.018L338.47 0L130.514 207.956L207.006 284.45L207.003 284.456ZM0 338.47L76.4969 261.962L152.988 338.454L76.4915 414.951L0 338.47ZM207.003 392.493L338.47 523.952L469.997 392.43L546.532 468.884L546.494 468.924L338.47 676.94L130.514 468.984L130.406 468.876L207.011 392.484L207.003 392.493ZM523.952 338.502L600.448 262.006L676.94 338.497L600.446 414.994L523.952 338.502Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M416.053 338.429H416.085L338.47 260.809L281.101 318.162L274.51 324.755L260.917 338.351L260.809 338.456L260.917 338.567L338.47 416.131L416.091 338.51L416.128 338.467L416.058 338.429",
    fill: "#F3BA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.986b9bebf81bc60ef29635381dfbf775.svg";
export { ForwardRef as ReactComponent };